import { render, staticRenderFns } from "./facility.vue?vue&type=template&id=dd88d226"
import script from "./facility.vue?vue&type=script&lang=js"
export * from "./facility.vue?vue&type=script&lang=js"
import style0 from "./facility.vue?vue&type=style&index=0&id=dd88d226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports